import { Checkbox, FormControlLabel } from '@material-ui/core'
import React from 'react'

const CustomCheckBox = ({ checked, onChange, label, disabled }) => {
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            sx={{
              '&.Mui-checked': {
                color: `rgba(96, 57, 187, 1)`,
              },
            }}
          />
        }
        label={label}
      />
    </>
  )
}

export default CustomCheckBox
